module.exports = __webpack_public_path__ + "static/media/clock.f34127b6.svg";